/**
 * ResultMsg is used for logan-web to show failure reasons or report results.
 */
export var ResultMsg;
(function (ResultMsg) {
    ResultMsg["DB_NOT_SUPPORT"] = "IndexedDB is not supported";
    ResultMsg["NO_LOG"] = "No log exists";
    ResultMsg["REPORT_LOG_SUCC"] = "Report succ";
    ResultMsg["REPORT_LOG_FAIL"] = "Report fail";
    ResultMsg["REPORT_LOG_PART_FAIL"] = "Report part fail";
    ResultMsg["DELETE_LOG_FAIL"] = "delete log fail";
    ResultMsg["EXCEED_TRY_TIMES"] = "Exceed try times";
    ResultMsg["EXCEED_LOG_SIZE_LIMIT"] = "Exceed log size day limit";
    ResultMsg["EXCEED_SINGLE_LOG_SIZE_LIMIT"] = "Single log is too large";
})(ResultMsg || (ResultMsg = {}));
/**
 * logan-web now supports two kinds of log mode. PLAIN mode is used for log() method. And RSA mode is used for logWithEncryption() method.
 *
 * PLAIN mode means that log saved in DB will only be encoded by base64, almost plaintext and can be easily obtained by local user.
 *
 * RSA mode means that logs will be hybrid encrypted before saved and it is very difficult to be cracked after then.
 *
 */
export var LogEncryptMode;
(function (LogEncryptMode) {
    LogEncryptMode[LogEncryptMode["PLAIN"] = 0] = "PLAIN";
    LogEncryptMode[LogEncryptMode["RSA"] = 1] = "RSA";
})(LogEncryptMode || (LogEncryptMode = {}));
export var LogType;
(function (LogType) {
    LogType[LogType["LEVEL1"] = 1] = "LEVEL1";
    LogType[LogType["LEVEL2"] = 2] = "LEVEL2";
    LogType[LogType["LEVEL3"] = 3] = "LEVEL3";
    LogType[LogType["LEVEL4"] = 4] = "LEVEL4";
    LogType[LogType["LEVEL5"] = 5] = "LEVEL5";
    LogType[LogType["TRACK"] = 6] = "TRACK";
    LogType[LogType["XHR"] = 7] = "XHR";
    LogType[LogType["FETCH"] = 8] = "FETCH";
    LogType[LogType["HISTORY"] = 9] = "HISTORY";
    LogType[LogType["DOM"] = 10] = "DOM";
    LogType[LogType["INIT"] = 11] = "INIT";
    LogType[LogType["CONSOLE"] = 12] = "CONSOLE";
    LogType[LogType["CRASH"] = 13] = "CRASH";
    LogType[LogType["NATIVEAPI"] = 14] = "NATIVEAPI";
    LogType[LogType["UNHANDLEDREJECTION"] = 15] = "UNHANDLEDREJECTION";
    LogType[LogType["ERROR"] = 16] = "ERROR";
})(LogType || (LogType = {}));
// 百纳上报地址，每个业务线一个
export var BAINA_API_KEY;
(function (BAINA_API_KEY) {
    BAINA_API_KEY["likee"] = "likee";
    BAINA_API_KEY["pay"] = "pay";
    BAINA_API_KEY["helloyo"] = "helloyo";
    BAINA_API_KEY["hello"] = "hello";
    BAINA_API_KEY["imo"] = "imo";
    BAINA_API_KEY["bigolive"] = "bigolive";
    BAINA_API_KEY["tiki"] = "tiki";
})(BAINA_API_KEY || (BAINA_API_KEY = {}));
export var BAINA_API;
(function (BAINA_API) {
    BAINA_API["likee"] = "//support-json.like.video/json";
    BAINA_API["pay"] = "//support-json.bdesk.tech/json";
    BAINA_API["helloyo"] = "//support-json.helloyo.sg/json";
    BAINA_API["hello"] = "//support-json.ppx520.com/json";
    BAINA_API["imo"] = "//support-json.imoim.net/json";
    BAINA_API["bigolive"] = "//support-json.ukyuh.tech/json";
    BAINA_API["tiki"] = "//bflow.tiki.video/json";
})(BAINA_API || (BAINA_API = {}));
